module.exports = __webpack_public_path__ + "img/art-school-icon4.4b00d43b.png";